import { render, staticRenderFns } from "./message-preview-draft.vue?vue&type=template&id=b3e297f2"
import script from "./message-preview-draft.vue?vue&type=script&lang=js"
export * from "./message-preview-draft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports